import { render, staticRenderFns } from "./bank-transfers-list.vue?vue&type=template&id=6b58c07c&"
import script from "./bank-transfers-list.vue?vue&type=script&lang=ts&"
export * from "./bank-transfers-list.vue?vue&type=script&lang=ts&"
import style0 from "./bank-transfers-list.vue?vue&type=style&index=0&id=6b58c07c&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports